module.exports = __webpack_public_path__ + "static/media/23-7.b501904e.mp3";